<div class="left-panel">
  <!-- Your logo or content here -->

  <img src="{{staffyLogo}}" alt="Logo" class="logo" [class] = "{'hospitality-logo': expertise === 'Hospitality'}"/>
</div>
